import React, { CSSProperties, forwardRef, ReactNode, useImperativeHandle } from 'react';
import { useNavigate } from 'react-router-dom';
import ReactVirtualizedAutoSizer, { Size } from 'react-virtualized-auto-sizer';
import { FixedSizeList } from 'react-window';
import { Author, tblName } from '../../libraries/db-types';
import { countFormat } from '../../libraries/utilities';
import { SearchHistory } from '../../services/local-storage-service';
import DB from '../../services/storage-service';
import Icon from '../icons/icons';
import { LocationState } from '../page-stack';
import Spacer from '../spacer/spacer';
import './dens-list-view.scss';

type Props = {
  type?: 'histories' | 'terms',
  view?: boolean;
  items: SearchHistory[] | Author[],
  title?: string,
  children?: ReactNode,
  onListClick?: (words: string) => void
  onDeleteClick?: (data: SearchHistory, index: number) => void
}

const DensListView = forwardRef<unknown, Props>((props, ref) => {

  useImperativeHandle(ref, () => ({
    scrollToTop: () => listRef.current?.scrollTo(0)
  }));

  const navigate = useNavigate();
  const listRef = React.createRef<FixedSizeList<any>>();

  const onListClick = (data: SearchHistory | Author, index: number) => {
    if (props.type === 'histories') {
      props.onListClick && props.onListClick((data as SearchHistory).words);
    } else {
      const updateData = (data as Author);
      updateData.view += 1
      DB.updateData(tblName.Authors, (data as Author).id, updateData);
      DB.getPostsByAuthor((data as Author).name).then(ret => {
        ret.length && navigate('/list', { state: {
          items: ret,
          title: `# ${(data as Author).name}`,
          view: 'list',
         } as LocationState});
      });
    }
  }

  const onDeleteClick = (ev: React.MouseEvent<HTMLSpanElement, MouseEvent>, data: SearchHistory, index: number) => {
    ev.stopPropagation();
    props.onDeleteClick && props.onDeleteClick(data, index);
  }

  const Row = (p: {
    data: SearchHistory | Author,
    index: number,
    style: CSSProperties,
  }) => {
    return <div className={`dens-list-item${ props.type === 'terms' ? ' has-right-icon' : ''}`} style={p.style} onClick={() => onListClick(p.data, p.index)}>
      {props.type === 'histories' 
        ? <Icon name='search' onClick={() => {}}></Icon>
        : <i className='icon-label'></i>}
      <span className='words' dangerouslySetInnerHTML={{__html: props.type === 'histories' ? (p.data as SearchHistory).words : (p.data as Author).name}}></span>
      <Spacer></Spacer>
      {(props.type !== 'histories' && props.view) ? <span className='count view-count'>
        <Icon name='views' onClick={() => {}}></Icon>
        {countFormat((p.data as Author).view)}
      </span> : null}
      <span className='count'>
        {/* {props.type !== 'histories' ? <Icon name='article' onClick={() => {}}></Icon> : null} */}
        {countFormat(props.type === 'histories' ? (p.data as SearchHistory).count : (p.data as Author).count)}
      </span>
      {/* {props.type === 'terms' && <span className='view-count'>{(p.data as Term).view}</span>} */}
      {props.type === 'histories' && <span className='del-button' onClick={ev => onDeleteClick(ev, p.data as SearchHistory, p.index)}>×</span>}
    </div>
  }

  return <>
  {props.items.length ?
  <ReactVirtualizedAutoSizer>
    {({ height, width }: Size) => {
      return <FixedSizeList
        ref={listRef}
        height={height}
        width={width}
        itemCount={props.items.length}
        itemSize={48}
      >
        {p => Row({...p, data: props.items[p.index]})}
      </FixedSizeList>
    }}
  </ReactVirtualizedAutoSizer>
  :
    <div>{props.children}</div>
  }
  </>
})
export default DensListView;
